import {CANALIZACIONHOGAR} from '../types';

const INITIAL_STATE = null;

const canalizacionHogar= (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case CANALIZACIONHOGAR :
            return  action.payload;
        default: return state
    }
};

export default canalizacionHogar;